import './index.less';
import '@abb/abb-common-ux-react/styles.css';

import * as React from 'react';
import { Button, message } from 'antd';
import { AbbBar, AppContainer, AppFooter, LoadingIndicator } from '@abb/abb-common-ux-react';
import { MaintainInfoDto, UserServiceProxy } from '../../services/serviceProxy';
import abbLogoRed from './abb-logo-red.svg';

export interface IMaintainPageProps {
  message?: string | null;
}

const DEFAULT_MESSAGE = '系统维护中';

/** 是否处于维护阻断状态：enabled === true 时展示维护页 */
export const isMaintainBlocking = (info?: MaintainInfoDto | null) => info?.enabled === true;

const MaintainPage: React.FC<IMaintainPageProps> = ({ message: maintainMessage }) => {
  const [displayMessage, setDisplayMessage] = React.useState(
    (maintainMessage && maintainMessage.trim()) || DEFAULT_MESSAGE
  );
  const [loading, setLoading] = React.useState(false);
  const year = new Date().getFullYear();

  const handleRefresh = async () => {
    if (loading) {
      return;
    }
    setLoading(true);
    const hideTip = message.loading('刷新中...', 0);
    try {
      const maintainInfo = await new UserServiceProxy().getMaintainInfo();
      if (isMaintainBlocking(maintainInfo)) {
        setDisplayMessage((maintainInfo?.message && maintainInfo.message.trim()) || DEFAULT_MESSAGE);
        hideTip();
        message.info('系统仍在维护中，请稍后再试');
        setLoading(false);
        return;
      }
      hideTip();
      message.success('维护已结束，正在进入系统...');
      // 维护已结束，整页重载进入正常流程
      window.location.reload();
    } catch {
      hideTip();
      message.error('刷新失败，请稍后重试');
      setLoading(false);
    }
  };

  return (
    <AppContainer className="maintain-page">
      {loading && (
        <div className="maintain-page__loading-bar">
          <LoadingIndicator color="red" determinate={false} type="bar" sizeClass="small" />
        </div>
      )}

      <div className="maintain-page__header">
        <AbbBar productName="ABB Motor Sales Portal" />
      </div>

      <div className="maintain-page__body">
        <div className={`maintain-page__content${loading ? ' is-loading' : ''}`}>
          <div className="maintain-page__logo">
            <img src={abbLogoRed} alt="ABB" />
          </div>
          <h1 className="maintain-page__title">系统维护</h1>
          <p className="maintain-page__message">{displayMessage}</p>
          <Button type="primary" size="large" loading={loading} onClick={handleRefresh}>
            {loading ? '刷新中' : '刷新'}
          </Button>
        </div>
      </div>

      <AppFooter className="maintain-page__footer" style={{ textAlign: 'center' }}>
        © Copyright 2021-{year} ABB |{' '}
        <a target="_blank" rel="noreferrer" href="http://beian.miit.gov.cn/">
          京ICP备13053479号-2
        </a>{' '}
        |{' '}
        <a target="_blank" rel="noreferrer" href="http://www.beian.gov.cn/portal/index">
          京公网安备 11010502037293号
        </a>
      </AppFooter>
    </AppContainer>
  );
};

export default MaintainPage;
